import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/exclamation-triangle.svg'
import BaseIcon from '../../BaseIcon'

const ExclamationTriangle = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 576 512" />
}

ExclamationTriangle.propTypes = {
	className: PropTypes.string,
}

export default ExclamationTriangle
